import React from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import valide from '../../../../assets/images/valide.png';
import firma from '../../../../assets/images/firma.png';
import './ModalAyuda.scss';
import ValidationContent from '../ModalValidacionFirma/ValidationContent';

/**
 * Modal para mostrar información de ayuda
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @returns {React.ReactElement} - Componente ModalAyuda
 */
const ModalAyuda = ({ show, onClose }) => (
    <AUIModal
      autoHeight
      size="xl"
      show={show}
      title="Ayuda"
      actionButtons={[
        {
          id: 'tertiary',
          mode: 'tertiary',
          label: 'Volver',
          onClick: onClose,
          disabled: false,
        },
      ]}
      onClose={onClose}
    >
      <div className="modal-content modal-ayuda-content">
        {/* Sección 1 */}
        <section className="modal-ayuda-section">
          <h3 className="modal-ayuda-title">
            Comprobar la validez de la firma mediante la Sede Electrónica Notarial
          </h3>
          <p className="modal-ayuda-description">
            Para comprobar la validez de la firma electrónica cualificada del notario en el documento notarial,
            haz clic en el botón <strong>Acciones</strong> y selecciona la opción <strong>Validar firma</strong>.
          </p>
          <div className="modal-ayuda-image">
            <ValidationContent />
          </div>
        </section>

        {/* Sección 2 */}
        <section className="modal-ayuda-section">
          <h3 className="modal-ayuda-title">
            Comprobar la validez de la firma mediante Adobe Acrobat Reader
          </h3>
          <p className="modal-ayuda-description">
            Para comprobar la validez de la firma electrónica cualificada del notario en el documento notarial,
            haz clic en el botón <strong>Acciones</strong> y selecciona la opción <strong>Descargar</strong>. Después, abre el documento con
            Adobe Acrobat Reader y haz clic en el icono de la pluma situado en el menú lateral.
            <br /><br />
            En la lista desplegable podrás comprobar la validez de la firma y analizar sus detalles.
          </p>
          <div className="modal-ayuda-image">
            <img src={firma} alt="Validar firma mediante Sede Electrónica" />
          </div>
        </section>

        {/* Sección 3 */}
        <section className="modal-ayuda-section">
          <h3 className="modal-ayuda-title">
            Comprobar la validez de la firma mediante VALIDe
          </h3>
          <p className="modal-ayuda-description">
            Para comprobar la validez de la firma electrónica cualificada del notario en el documento notarial,
            haz clic en el botón <strong>Acciones</strong> y selecciona la opción <strong>Descargar</strong>. Después, utiliza la{' '}
            <a
              href="https://valide.redsara.es/"
              target="_blank"
              rel="noopener noreferrer"
              className="modal-ayuda-link"
            >
              plataforma pública VALIDe
            </a>.
          </p>
          <div className="modal-ayuda-image">
            <img src={valide} alt="Validar firma con VALIDe" />
          </div>
        </section>
      </div>
    </AUIModal>
  );

ModalAyuda.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalAyuda;
